import { render, staticRenderFns } from "./CarrierAccountsTable.vue?vue&type=template&id=80708540"
import script from "./CarrierAccountsTable.vue?vue&type=script&lang=ts"
export * from "./CarrierAccountsTable.vue?vue&type=script&lang=ts"
import style0 from "./CarrierAccountsTable.vue?vue&type=style&index=0&id=80708540&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports